<div class="time-sync-definition">

    <sc-actionbar [footerLine]="true">
        <button mat-stroked-button [disabled]="isLoading || !cancelEnabled" (click)="cancel()">
            {{'cancel' | translate: ['shared.action.cancel',
            translationService.language]}}
        </button>
        <sc-content-spacer></sc-content-spacer>
        <button mat-flat-button (click)="save()" [disabled]="isLoading || !saveEnabled">
            {{'save' | translate: ['shared.action.save',
            translationService.language]}}
        </button>
    </sc-actionbar>

    <div class="details" [formGroup]="detailsFormGroup">
        <div class="field">
            <mat-slide-toggle formControlName="syncArrivalDate" name="syncArrivalDate">
                {{'sync arrival date' | translate:
                ['tmc-yard.entity.time-sync-definition.sync-arrival-date',translationService.language]}}
            </mat-slide-toggle>
        </div>
        <sc-content-spacer [vertical]="true"></sc-content-spacer>
        <div class="field">
            <mat-slide-toggle formControlName="syncProcessingEnd" name="syncProcessingEnd">
                {{'sync processing end' | translate:
                ['tmc-yard.entity.time-sync-definition.sync-processing-end',translationService.language]}}
            </mat-slide-toggle>
        </div>
        <sc-content-spacer [vertical]="true"></sc-content-spacer>
        <div class="field">
            <mat-slide-toggle formControlName="syncStatusWaiting" name="syncStatusWaiting">
                {{'sync status waiting' | translate:
                ['tmc-yard.entity.time-sync-definition.sync-status-waiting',translationService.language]}}
            </mat-slide-toggle>
        </div>
        <sc-content-spacer [vertical]="true"></sc-content-spacer>
        <div class="field">
            <mat-slide-toggle formControlName="syncStatusProcessing" name="syncStatusProcessing">
                {{'sync status processing' | translate:
                ['tmc-yard.entity.time-sync-definition.sync-status-processing',translationService.language]}}
            </mat-slide-toggle>
        </div>
        <sc-content-spacer [vertical]="true"></sc-content-spacer>
        <div class="field">
            <mat-slide-toggle formControlName="syncStatusPaused" name="syncStatusPaused">
                {{'sync status paused' | translate:
                ['tmc-yard.entity.time-sync-definition.sync-status-paused',translationService.language]}}
            </mat-slide-toggle>
        </div>
        <sc-content-spacer [vertical]="true"></sc-content-spacer>
        <div class="field">
            <mat-slide-toggle formControlName="syncStatusCancelled" name="syncStatusCancelled">
                {{'sync status cancelled' | translate:
                ['tmc-yard.entity.time-sync-definition.sync-status-cancelled',translationService.language]}}
            </mat-slide-toggle>
        </div>
        <sc-content-spacer [vertical]="true"></sc-content-spacer>
        <div class="field">
            <mat-slide-toggle formControlName="syncStatusFinished" name="syncStatusFinished">
                {{'sync status finished' | translate:
                ['tmc-yard.entity.time-sync-definition.sync-status-finished',translationService.language]}}
            </mat-slide-toggle>
        </div>
    </div>

    <app-service-response [responseMessages]="responseMessages"></app-service-response>
</div>